module.exports = __webpack_public_path__ + "static/Sam-adams-competitors-fa753ad2cb505d7713f4dbb0a180953a.png";